import { getNetTermsDays } from './dateUtils';

const CLOSED_WITHOUT_OPEN_BALANCE_STATUSES = new Set(['CANCELLED', 'REFUNDED']);
const FULLY_PAID_PAYMENT_STATUSES = new Set(['PAID', 'CAPTURED', 'REFUNDED']);
const CAPTURED_PAYMENT_STATUSES = new Set(['CAPTURED', 'COMPLETED', 'PAID']);

const asNumber = (value) => Number(value || 0);

export const isClosedWithoutOpenBalance = (order) => {
  const orderStatus = String(order?.status || '').toUpperCase();
  const paymentStatus = String(order?.paymentStatus || '').toUpperCase();
  return (
    CLOSED_WITHOUT_OPEN_BALANCE_STATUSES.has(orderStatus) ||
    CLOSED_WITHOUT_OPEN_BALANCE_STATUSES.has(paymentStatus)
  );
};

export const getInvoiceDetails = (order) => {
  const rawTotal = asNumber(order?.totalAmount || order?.amount);
  const totalAmount =
    order?.adjustedTotalAmount != null && asNumber(order.adjustedTotalAmount) >= 0
      ? asNumber(order.adjustedTotalAmount)
      : order?.triceraInvoiceTotal != null && asNumber(order.triceraInvoiceTotal) >= 0
      ? asNumber(order.triceraInvoiceTotal)
      : rawTotal;
  const paymentsTotal = asNumber(
    order?.payments?.reduce(
      (sum, payment) =>
        CAPTURED_PAYMENT_STATUSES.has(String(payment.status || '').toUpperCase())
          ? sum + asNumber(payment.amount)
          : sum,
      0
    )
  );
  const manualPaid = asNumber(order?.manualPaymentAmount);
  const paymentStatus = String(order?.paymentStatus || '').toUpperCase();
  const paidAmount = FULLY_PAID_PAYMENT_STATUSES.has(paymentStatus)
    ? totalAmount
    : paymentsTotal + manualPaid;
  const balance = Math.max(0, totalAmount - paidAmount);

  const orderDate = new Date(order?.orderDate || order?.createdAt);
  const netDays = getNetTermsDays(order?.paymentTerms);
  const netDueDate = new Date(orderDate.getTime() + netDays * 24 * 60 * 60 * 1000);
  const discountDate = order?.promptPayDeadline ? new Date(order.promptPayDeadline) : null;
  const now = new Date();
  const daysSinceOrder = Math.floor((now - orderDate) / (1000 * 60 * 60 * 24));
  const earlyPaymentEligible =
    order?.promptPayEligible && discountDate && now <= discountDate && balance > 0;
  const ppPercent = order?.promptPayDiscountPercent ? asNumber(order.promptPayDiscountPercent) : 0;
  const discountAmount = earlyPaymentEligible && ppPercent > 0 ? balance * (ppPercent / 100) : 0;

  return {
    totalAmount,
    paidAmount,
    balance,
    orderDate,
    netDueDate,
    discountDate,
    earlyPaymentEligible,
    discountAmount,
    daysSinceOrder,
  };
};

export const hasOpenBalance = (order) =>
  !isClosedWithoutOpenBalance(order) && getInvoiceDetails(order).balance > 0;
